"use client";
import { usePathname } from "next/navigation";
import { useUser } from "@clerk/nextjs";
import AuthSignInButton from "@/components/AuthSignInButton";
import { ActionIcon, Box as MantineBox, Text as MantineText } from "@mantine/core";
import { IconHeart } from "@tabler/icons-react";
import { useUiStore } from "@/stores/uiStore";
import { useCollectionsStore } from "@/stores/collectionsStore";

import styles from "./styles.module.scss";

type FavoriteButtonProps = {
  forceShow?: boolean;
  size?: number;
  showCount?: boolean;
};

const FavoriteButton = ({
  forceShow = false,
  size = 24,
  showCount = true,
}: FavoriteButtonProps) => {
  const pathname = usePathname();
  const { isSignedIn } = useUser();
  const toggleFavoritesModal = useUiStore((state) => state.actions.toggleFavoritesModal);
  const favoriteCount = useCollectionsStore((state) => state.activeCollectionItems?.length ?? 0);
  const iconSize = Math.max(16, size - 4);

  if (!forceShow && pathname !== "/search" && pathname !== "/spotlight") {
    return null;
  }

  const onClick = () => {
    toggleFavoritesModal();
  };

  return (
    <>
      {isSignedIn ? (
        <MantineBox className={styles.iconWrap}>
          <ActionIcon
            className={styles.favButton}
            onClick={onClick}
            aria-label="Open favorites"
            title="Open favorites"
            data-locked={false}
            variant="transparent"
            radius="sm"
            size={44}
          >
            <IconHeart size={iconSize} />
          </ActionIcon>
          {showCount && favoriteCount > 0 && (
            <MantineText span className={styles.badge}>
              {favoriteCount}
            </MantineText>
          )}
        </MantineBox>
      ) : (
        <AuthSignInButton>
          {/* eslint-disable-next-line no-restricted-syntax -- Clerk must clone a native element. */}
          <button
            className={styles.favButton}
            aria-label="Sign in to view favorites"
            title="SIGN IN TO VIEW FAVORITES"
            data-locked={true}
            type="button"
          >
            <IconHeart size={iconSize} stroke={1.5} style={{ pointerEvents: "none" }} />
          </button>
        </AuthSignInButton>
      )}
    </>
  );
};

export default FavoriteButton;
